const homeOptions = [
  '1 BR',
  '2 BR',
  '2 BR + D',
  '3 BR',
];

export default homeOptions;
